import {
  AnularRechazoOrdenRequest,
  CambioOrientacion,
  CambioOrientacionConfiguracion,
  CambioOrientacionFiltro,
  CambioOrientacionPage,
  OperacionOrdenesRequest,
  ResultadoAnularRechazo,
  ResultadoOperacion
} from 'src/app/domain/model/cambio-orientacion/cambio-orientacion';

/**
 * Repository: CambioOrientacionRepository
 * 
 * Puerto de salida para operaciones de cambios en orientaciones.
 * Implementación: HttpCambioOrientacionRepository
 * 
 * Legacy: OrdersHandler.java - métodos bajarSaldoRechazarOrden, rechazarOrden
 */
export abstract class CambioOrientacionRepository {
  /**
   * Obtiene configuración funcional de cambio de orientación.
   */
  abstract obtenerConfiguracion(): Promise<CambioOrientacionConfiguracion>;

  /**
   * Obtiene el detalle completo de una orden por su consecutivo.
   * Usa query directo DETALLE_ORDEN en lugar del SP.
   */
  abstract obtenerDetalle(nmconsecutivo: number): Promise<CambioOrientacion>;

  /**
   * Busca órdenes que pueden ser rechazadas o tener su saldo bajado (paginación keyset;
   * la respuesta incluye cursores y total).
   */
  abstract buscarOrdenes(filtro: CambioOrientacionFiltro): Promise<CambioOrientacionPage>;

  /**
   * Rechaza una o más órdenes de servicio.
   */
  abstract rechazarOrdenes(request: OperacionOrdenesRequest): Promise<ResultadoOperacion[]>;

  /**
   * Baja el saldo de una o más órdenes de servicio.
   */
  abstract bajarSaldoOrdenes(request: OperacionOrdenesRequest): Promise<ResultadoOperacion[]>;

  /**
   * Anula la solicitud de rechazo de una orden de servicio.
   */
  abstract anularRechazoOrden(request: AnularRechazoOrdenRequest): Promise<ResultadoAnularRechazo>;
}
